module.exports = __webpack_public_path__ + "img/4.14910548.png";